// extracted by mini-css-extract-plugin
export default {"menuIcon":"SubUnitMenu__menuIcon___S86hA","menu":"SubUnitMenu__menu___BihA2"};